/* CABELO — Open first routine step by default (Quiz + Routine Results)
   Safe approach:
   - Tries a real click first (so your existing logic runs)
   - Falls back to setting aria-expanded + un-hiding panel if needed
*/
(function () {
  function openFirstStep(container) {
    const toggle = container.querySelector('.cabelo-step__toggle, .routine-step-toggle');
    if (!toggle) return;

    if (toggle.getAttribute('aria-expanded') === 'true') return;

    // Try to trigger your existing accordion handler
    toggle.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

    // Fallback (in case the accordion uses attribute toggling only)
    setTimeout(() => {
      if (toggle.getAttribute('aria-expanded') === 'true') return;

      toggle.setAttribute('aria-expanded', 'true');

      const panelId = toggle.getAttribute('aria-controls');
      let panel = null;

      if (panelId && window.CSS && CSS.escape) {
        panel = container.querySelector('#' + CSS.escape(panelId));
      }

      if (!panel) {
        panel = toggle.closest('.cabelo-step')?.querySelector('.cabelo-step__panel, .routine-step-panel');
      }

      if (panel) {
        panel.hidden = false;
        panel.removeAttribute('hidden');
      }
    }, 0);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('[id^="cabelo-quiz-results-"], [id^="cabelo-routine-results-"]')
      .forEach(openFirstStep);
  });
})();
